var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientOutOfRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 29.2,
    width: 1,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,13.3L20.8,5.2c-0.2-0.1-0.8-0.1-1,0l-14,8.2c-0.3,0.1-0.5,0.4-0.4,0.7c0.1,0.3,0.4,0.5,0.7,0.5h4.2v20.3h1V13.7 l16.5,0V18c0.3,0,0.7,0,1,0v-3.4h3.9c0.3,0,0.6-0.2,0.7-0.5C33.5,13.8,33.3,13.5,33,13.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,23.7l-2.8-4.2c-0.1-0.2-0.4-0.3-0.6-0.4L29.4,19c-0.7-0.1-1.2,0.7-0.8,1.3c0.3,0.4,0,1-0.5,1 c-0.6,0-1.1,0.1-1.6,0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.2-0.8,0.4-1.2,0.6c-0.9,0.5-1.8,1.3-2.5,2.2c-0.9,1.2-1.7,2.8-2.2,4.6 c0,0.2,0.1,0.3,0.3,0.2c0.3-0.2,3.2-2.3,4.4-2.9c0.1,0,0.1-0.1,0.2-0.1c0.8-0.3,1.5-0.5,2.3-0.6c0.6-0.1,1.2-0.1,1.7,0 c0.1,0,0.2,0.2,0.1,0.3l-1.5,1.4c-0.1,0.1-0.1,0.3,0.1,0.4l3,0.4c0.2,0,0.5,0,0.7-0.2l3.8-3.3C34.6,24.5,34.7,24,34.4,23.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOutOfRoom);
export default __webpack_public_path__ + "static/media/client-out-of-room.c938c3834c0d14d39e1461ec3cd6e012.svg";
export { ForwardRef as ReactComponent };